import http from '@/utils/request'

const endpoint = 'analytics/user-behaviors'

export default {
  fields: {
    url: `${endpoint}/fields`,
    get: async function () {
      return await http.get(this.url)
    }
  },
  groups: {
    url: `${endpoint}/groups`,
    get: async function () {
      return await http.get(this.url)
    }
  },
  query: {
    url: `${endpoint}/query`,
    post: async function (data) {
      return await http.post(this.url, data)
    }
  },
  details: {
    url: `${endpoint}/details`,
    post: async function (data) {
      return await http.post(this.url, data)
    }
  },
  labels: {
    url: `${endpoint}/labels`,
    get: async function () {
      return await http.get(this.url)
    },
    post: async function (data) {
      return await http.post(this.url, data)
    }
  },
  label: {
    url: `${endpoint}/labels`,
    get: async function (id) {
      return await http.get(`${this.url}/${id}`)
    },
    put: async function (id, data) {
      return await http.put(`${this.url}/${id}`, data)
    },
    delete: async function (id) {
      return await http.delete(`${this.url}/${id}`)
    }
  }
}
